import { useState } from "react";

export function usePagination() {
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  return {
    page,
    setPage,

    perPage,
    setPerPage: (value: number) => {
      setPage(1);
      setPerPage(value);
    },
  };
}
